<template>
  <div ref="import" class="page-import-detail" style="height:100vh">
    <!-- 导入结果信息头 -->
    <div class="page-detail-header">
      <el-row>
        <el-col :span="22">
          <!-- 重复详情 -->
          <span v-show="type === 'REPEAT'"></span>
          <!-- 校验详情 -->
          <span v-show="type === 'VALIDATE'">
            企业校验详情 （{{ table.success }}条数据校验成功，{{ table.error }}条数据校验失败）
          </span>
          <!-- 导入详情 -->
          <span v-show="type === 'IMPORT'">
            企业导入详情 （{{ table.success }}条数据导入成功，{{ table.error }}条数据导入失败）
          </span>
        </el-col>
        <!-- 暂时只有导入详情的导出 -->
        <el-col v-show="type === 'IMPORT'" :span="2">
          <el-button
            :disabled="!table.data.length"
            icon="h-icon-export"
            @click="handlerExportTable"
          >
            导出
          </el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 导入结果信息主体 -->
    <div class="page-detail-body">
      <!-- 校验结果 -->
      <el-table
        v-if="type === 'VALIDATE'"
        v-loading="isLoading"
        :data="table.data"
        :force-scroll="true"
        stripe
        show-overflow-title
        @on-scrolling-y="handlerScroll"
        @filter-change="handlerFilterTable"
      >
        <el-table-column label="位置" width="300px" prop="lineNum">
          <template slot-scope="scope">
            <span :class="{ 'page-detail-failed': !scope.row.success }">
              第{{ scope.row.index }}行
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="校验结果"
          :filters="[
            { text: '成功', value: true },
            { text: '失败', value: false }
          ]"
          width="200px"
          show-overflow-tooltip
          prop="successNum"
          filter-placement="bottom-start"
          column-key="filter"
        >
          <template slot-scope="scope">
            <span :class="{ 'page-detail-failed': !scope.row.success }">
              {{ scope.row.success ? '成功' : '失败' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="校验详情" prop="reason">
          <template slot-scope="scope">
            <span :class="{ 'page-detail-failed': !scope.row.success }">
              {{ scope.row.message || ' ' }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 导入结果 -->
      <el-table
        v-if="type === 'IMPORT'"
        v-loading="isLoading"
        :data="table.data"
        :force-scroll="true"
        stripe
        show-overflow-title
        @on-scrolling-y="handlerScroll"
        @filter-change="handlerFilterTable"
      >
        <el-table-column label="位置" width="300px" prop="index">
          <template slot-scope="scope">
            <span :class="{ 'page-detail-failed': !scope.row.result }">
              第{{ scope.row.index }}行
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="导入结果"
          :filters="[
            { text: '成功', value: true },
            { text: '失败', value: false }
          ]"
          width="200px"
          show-overflow-tooltip
          prop="successNum"
          filter-placement="bottom-start"
          column-key="filter"
        >
          <template slot-scope="scope">
            <span :class="{ 'page-detail-failed': !scope.row.result }">
              {{ scope.row.success ? '成功' : '失败' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="导入详情" prop="message">
          <template slot-scope="scope">
            <span :class="{ 'page-detail-failed': !scope.row.result }">
              {{ scope.row.message || ' ' }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 重复结果 -->
      <el-table
        v-if="type === 'REPEAT'"
        v-loading="isLoading"
        :data="table.data"
        :force-scroll="true"
        stripe
        show-overflow-title
        @on-scrolling-y="handlerScroll"
      >
        <el-table-column label="位置" width="300px" prop="index">
          <template slot-scope="scope">第{{ scope.row.index }}行</template>
        </el-table-column>
        <el-table-column label="重复详情" prop="message">
          <template slot-scope="scope">
            {{ scope.row.message || ' ' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import api from '@/api/companyManage.api'
import CON from './constant'
import qs from 'qs'

export default {
  name: 'CompanyImportDetail',

  data() {
    return {
      isLoading: false,
      type: '', // 校验/重复/导入
      query: {
        status: undefined, // 查询列表类型
        validateCode: '', // 查看校验详情时要使用的标识
        importCode: '', // 查看重复详情时要使用的标识
        batchUUid: 0, // 查询code码
        pageNo: 1, // 页数
        pageSize: 50, // 每页条数,
        isRepeat: undefined // 是否是重复信息
      },
      table: {
        data: [],
        error: 0, // 失败数目
        success: 0, // 成功数目
        repeat: 0 // 重复数目
      }
    }
  },

  computed: {
    // 导入详情的筛选条件
    importDetailParams() {
      return {
        status: this.query.status,
        batchUUid: this.query.batchUUid,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize
      }
    },
    // 校验详情的筛选条件
    validateDetailParams() {
      return {
        status: this.query.status,
        batchUUid: this.query.batchUUid,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize
      }
    },
    // 重复详情的筛选条件
    repeatDetailParams() {
      return {
        batchUUid: this.query.batchUUid,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize
      }
    }
  },

  created() {
    /*
     * 传参方式变一下，从params转为query，这里主要是hui-pro脚手架不支持有重名部分的路由
     * 例如：配置了/import之后，如果再配置/import/detail会导致/import/detail无法识别，直接报错
     */
    // const params = this.$route.params;
    const params = this.$route.query
    if (!params) return
    this.type = params.type

    Object.assign(this.query, {
      batchUUid: params.batchUUid,
      isRepeat: this.type === CON.IMPORT_TYPE.REPEAT ? 1 : undefined,
      status:
        this.type === CON.IMPORT_TYPE.IMPORT
          ? `${CON.IMPORT_QUERY_TYPE.IMPORT_SUCCESS},${CON.IMPORT_QUERY_TYPE.IMPORT_FAIL}`
          : `${CON.IMPORT_QUERY_TYPE.VALIDATE_SUCCESS},${CON.IMPORT_QUERY_TYPE.VALIDATE_FAIL}`
    })

    this.getTable()
  },

  methods: {
    /**
     * @Author: zhuxiankang
     * @Date:   2018-03-09 21:16:37
     * @Desc:   获取列表信息
     * @Parm:
     */
    async getTable() {
      // 定义不同模式下的处理方法映射表
      const getTableMethodMap = {
        REPEAT: this.getRepeatDetail,
        VALIDATE: this.getValidateDetail,
        IMPORT: this.getImportDetail
      }
      // 根据当前模式（导入/校验/重复），调用对应的方法
      getTableMethodMap[this.type]()
    },
    /*
     * @Author: jiangyan6
     * @Date: 2019-09-05 10:42:03
     * @Desc: 获取导入详情的方法
     * @param:
     * @return:
     */
    async getImportDetail() {
      this.isLoading = true
      // eslint-disable-next-line no-console
      const params = this.importDetailParams
      try {
        const { data } = await api.importValidateDetail(params)
        Object.assign(this.table, {
          data: this.table.data.concat(data.list || []),
          error: data.errorTotalNum, // 失败数目
          success: data.totalNum - data.errorTotalNum // 成功数目
        })
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
    /*
     * @Author: jiangyan6
     * @Date: 2019-09-05 10:42:03
     * @Desc: 获取校验详情的方法
     * @param:
     * @return:
     */
    async getValidateDetail() {
      this.isLoading = true
      const params = this.validateDetailParams
      try {
        const { data } = await api.importValidateDetail(params)
        Object.assign(this.table, {
          data: this.table.data.concat(data.list || []),
          error: data.errorTotalNum, // 失败数目
          success: data.totalNum - data.errorTotalNum // 成功数目
        })
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
    /*
     * @Author: jiangyan6
     * @Date: 2019-09-05 10:42:03
     * @Desc: 获取重复详情的方法
     * @param:
     * @return:
     */
    async getRepeatDetail() {
      this.isLoading = true
      const params = this.repeatDetailParams
      try {
        const { data } = await api.getImportResult(params)
        Object.assign(this.table, {
          data: this.table.data.concat(data.list || []),
          repeat: data.repeatNum
        })
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-03-09 20:24:14
     * @Desc:   导出列表信息
     * @Parm:
     */
    async handlerExportTable() {
      const url = `${location.origin}/${
        process.env.VUE_APP_CONTEXT
      }/ui/v1/enterpriseService/export/validate/detail?${qs.stringify({
        status: this.query.status,
        batchUUid: this.query.batchUUid
      })}`

      window.location.href = url
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-03-09 21:45:56
     * @Desc:   过滤列表信息
     * @Parm:
     */
    handlerFilterTable({ filter }) {
      if (!filter.length || filter.length === 2) {
        // 重置
        this.query.status =
          this.type === CON.IMPORT_TYPE.IMPORT
            ? `${CON.IMPORT_QUERY_TYPE.IMPORT_SUCCESS},${CON.IMPORT_QUERY_TYPE.IMPORT_FAIL}`
            : `${CON.IMPORT_QUERY_TYPE.VALIDATE_SUCCESS},${CON.IMPORT_QUERY_TYPE.VALIDATE_FAIL}`
      } else if (filter[0]) {
        // 成功
        this.query.status =
          this.type === CON.IMPORT_TYPE.IMPORT
            ? CON.IMPORT_QUERY_TYPE.IMPORT_SUCCESS
            : CON.IMPORT_QUERY_TYPE.VALIDATE_SUCCESS
      } else {
        // 失败
        this.query.status =
          this.type === CON.IMPORT_TYPE.IMPORT
            ? CON.IMPORT_QUERY_TYPE.IMPORT_FAIL
            : CON.IMPORT_QUERY_TYPE.VALIDATE_FAIL
      }
      this.table.data = []
      Object.assign(this.query, {
        pageNo: 1, // 页数
        pageSize: 50 // 每页条数
      })
      this.getTable()
    },

    // @description: 滚动加载
    // ------------------------------------------------------------------------------------------------
    /**
     * @Author: zhuxiankang
     * @Date:   2018-03-09 21:41:36
     * @Desc:   列表滚动加载
     * @Parm:
     */
    handlerScroll(scroll) {
      clearTimeout(this._timer)
      this._timer = setTimeout(() => {
        const bottom = this.getScrollBottom(document.querySelectorAll('.el-table__body')[0], scroll) // 距离底部的距离
        const table = this.table
        const query = this.query
        if (bottom < 100) {
          /* 如果是导入和校验结果显示,检测是否加载完毕 */
          if (
            (this.type === CON.IMPORT_TYPE.IMPORT || this.type === CON.IMPORT_TYPE.VALIDATE) &&
            table.success + table.error > table.data.length
          ) {
            /* 搜索默认数据 */
            if (!query.status && table.success + table.error > table.data.length) {
              query.pageNo++
              this.getTable()
              /* 搜索的是成功数据 */
            } else if (
              (query.status === CON.IMPORT_QUERY_TYPE.IMPORT_SUCCESS ||
                query.status === CON.IMPORT_QUERY_TYPE.VALIDATE_SUCCESS) &&
              table.success > table.data.length
            ) {
              query.pageNo++
              this.getTable()
              /* 搜索的是失败的数据 */
            } else if (
              (query.status === CON.IMPORT_QUERY_TYPE.IMPORT_FAIL ||
                query.status === CON.IMPORT_QUERY_TYPE.VALIDATE_FAIL) &&
              table.error > table.data.length
            ) {
              query.pageNo++
              this.getTable()
              /* 搜索的是成功和失败的数据 */
            } else if (
              (query.status ===
                `${CON.IMPORT_QUERY_TYPE.IMPORT_SUCCESS},${CON.IMPORT_QUERY_TYPE.IMPORT_FAIL}` ||
                query.status ===
                  `${CON.IMPORT_QUERY_TYPE.VALIDATE_SUCCESS},${CON.IMPORT_QUERY_TYPE.VALIDATE_FAIL}`) &&
              table.success + table.error > table.data.length
            ) {
              query.pageNo++
              this.getTable()
            } else {
              this.$message({
                type: 'success',
                message: '加载完毕'
              })
            }
            /* 如果是重复结果显示,检测是否加载完毕 */
          } else if (this.type === CON.IMPORT_TYPE.REPEAT && table.repeat > table.data.length) {
            query.pageNo++
            this.getTable()
            /* 加载完毕 */
          } else {
            this.$message({
              type: 'success',
              message: '加载完毕'
            })
          }
        }
      }, 100)
    },

    getScrollBottom(element, scrollTop) {
      let clientHeight = 0
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        // 视窗大小(不包含边框大小，只包含内容和它的内边距，如果有滚动条，也不包含)
        clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight
      } else {
        clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight
      }
      // scrollHeight: 滚动大小，指的是包含滚动内容的元素大小（元素内容的总高度）
      const documentHeight = element.scrollHeight
      // return documentHeight - clientHeight - scrollTop + document.querySelectorAll('.el-table__body-wrapper')[0].getBoundingClientRect().top
      // 107px是table的wrapper距离窗口(注意不是视口)的距离
      return documentHeight - clientHeight - scrollTop + 107
    }
  }
}
</script>
